module.exports = __webpack_public_path__ + "7de084a5490adee8ff5eeff8c087ddec.svg";